import { render, staticRenderFns } from "./RouterEditor.vue?vue&type=template&id=3d007361&scoped=true"
import script from "./RouterEditor.vue?vue&type=script&lang=js"
export * from "./RouterEditor.vue?vue&type=script&lang=js"
import style0 from "./RouterEditor.vue?vue&type=style&index=0&id=3d007361&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d007361",
  null
  
)

export default component.exports